import type {
  MultipleOpportunity,
  SingleAvailableOpportunity,
  SingleOpportunity,
  SingleSuspendedOrUnavailableOpportunity
} from '../../types/betSlip';

export const isSingleOpportunity = (
  opportunity: SingleOpportunity | MultipleOpportunity
): opportunity is SingleOpportunity => opportunity.type === 'SINGLE';

export const isAvailableOpportunity = (
  opportunity: SingleOpportunity | MultipleOpportunity
): opportunity is SingleAvailableOpportunity | MultipleOpportunity =>
  opportunity.status === 'AVAILABLE';

export const isSuspendedOpportunity = (
  opportunity: SingleOpportunity | MultipleOpportunity
): opportunity is SingleSuspendedOrUnavailableOpportunity =>
  isSingleOpportunity(opportunity) && opportunity.status === 'SUSPENDED';

export const isUnavailableOpportunity = (
  opportunity: SingleOpportunity | MultipleOpportunity
): opportunity is SingleSuspendedOrUnavailableOpportunity =>
  isSingleOpportunity(opportunity) && opportunity.status === 'UNAVAILABLE';

export const isMultipleOpportunity = (
  opportunity: SingleOpportunity | MultipleOpportunity
): opportunity is MultipleOpportunity => opportunity.type !== 'SINGLE';
